import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import findQuestionByRefId from 'utils/findQuestionByRefId';
import { selectQuestionnaireQuestions } from 'containers/QuestionnairePage/selectors';

const useGetParentGroup = (nodeRefId) => {
  const allNodes = useSelector(selectQuestionnaireQuestions);
  const group = useMemo(() => {
    const currentQuestion = findQuestionByRefId(allNodes, nodeRefId);
    if (!currentQuestion?.groupRefId) {
      return null;
    }
    return findQuestionByRefId(allNodes, currentQuestion.groupRefId);
  }, [allNodes, nodeRefId]);

  return group;
};

export default useGetParentGroup;
